import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { User } from 'src/app/modals/Authentication/auth.models';
import { Store } from '@ngrx/store';
import { RootReducerState } from '..';
import { fetchRecords } from './sent-correspondence.action';

@Injectable({ providedIn: 'root' })
export class SentCorrespondencesTableService {

    constructor(
        private store: Store<RootReducerState>,
    ) { }
 
    pagination = [];
    filters = {
                created_at: '',
                member_name: '',
                contact_info: '',
                type: null,
                status_text: null
            };

    page: number = 1;
    lastPage: number;
    limit: number = 10;
    initialSortColumn = 'created_at';
    initialSortDirection = 'desc';
    sortColumn = this.initialSortColumn;
    sortDirection = this.initialSortDirection;
    statuses = [
        {id: "1", name:"SENT_CORRESPONDENCE.queued"},
        {id: "2", name:"SENT_CORRESPONDENCE.sent"},
        {id: "3", name:"SENT_CORRESPONDENCE.failed"},
        {id: "4", name:"SENT_CORRESPONDENCE.failed-permanently"}
    ];

    types = [
        {id: "1", name:"CORRESPONDENCE.email"},
        {id: "2", name:"CORRESPONDENCE.whatsapp"},
        {id: "3", name:"CORRESPONDENCE.sms"},
        {id: "4", name:"CORRESPONDENCE.letter"}
    ];

    hasFilter = false;
    dossierId: string;
    columns = [
                { prop: 'created_at', name: 'SENT_CORRESPONDENCE.date-time', sortable: true, hasFilter: true, filter: "date"},
                { prop: 'member_name', name: 'SENT_CORRESPONDENCE.recipient', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'contact_info', name: 'SENT_CORRESPONDENCE.contact-info', sortable: true, hasFilter: true, filter: "input"},
                { prop: 'type', name: 'SENT_CORRESPONDENCE.type', sortable: false, hasFilter: true, filter: "select", options: 'types', options_id: "id", options_label: "name"},
                { prop: 'status_text', name: 'COMMON.status', sortable: false, hasFilter: true, filter: "select", options: 'statuses', options_id: "id", options_label: "name"},
            ];

    loadRecords() {
        this.hasFilter = this.hasActiveFilters();
        this.store.dispatch(fetchRecords({id: this.dossierId}));
    }

    hasActiveFilters(){

        if(
            (Object.values(this.filters).some(value => value !== '' && value !== null)) ||
            (this.sortDirection !== this.initialSortDirection || this.sortColumn !== this.initialSortColumn)
        )
            return true;
        else
            return false;        
    }

    resetFilters(){
        this.filters = {
            created_at: '',
            member_name: '',
            contact_info: '',
            type: null,
            status_text: null
        }

        this.sortDirection = this.initialSortDirection;
        this.sortColumn = this.initialSortColumn;

        this.loadRecords();
    }

}